<template>
  <div class="mt-4 flex items-center space-x-4">
    <div class="flex-1 flex items-center justify-between">
      <div>
        <slot name="description">
          <template v-if="isFixedAmount">
            <p class="font-bold leading-none">Fixed amount</p>
            <!-- eslint-disable-next-line max-len -->
            <p class="text-gray-600 text-sm leading-none" >This is the amount that will be set aside to start the pension. The rest of the member's account will remain in accumulation phase.</p>
          </template>
          <template v-if="isAccumLessFixed">
            <p class="font-bold leading-none">Less Fixed amount</p>
            <!-- eslint-disable-next-line max-len -->
            <p class="text-gray-600 text-sm leading-none">This is the amount that will remain in the accumulation account.  The rest of the accumulation balance will be converted to a pension.</p>
          </template>
        </slot>
      </div>
      <div v-if="isPartTwo">
        <m-badge>{{ accumAmount | dollar }}</m-badge>
      </div>
    </div>
    <div class="flex-1">
      <m-input-dollar
        id="fixed-amount"
        class="w-full"
        v-model.number="$v.fixedAmount.$model"
        :state="
          $v.fixedAmount.$dirty ? (!$v.fixedAmount.$invalid ? 'success' : 'error') : ''
        "
      ></m-input-dollar>
      <p
        v-if="
            isPartTwo &&
            $v.fixedAmount.$dirty &&
            !$v.fixedAmount.maxValue &&
            $v.fixedAmount.$invalid
        "
        id="fixed-amount-feedback"
        class="mt-1 text-red-500 text-sm leading-none"
      >
        Fixed amount must be less than the accumulation account.
      </p>
      <p
        v-if="
          $v.fixedAmount.$dirty && !$v.fixedAmount.minValue && $v.fixedAmount.$invalid
        "
        id="fixed-amount-feedback"
        class="mt-1 text-red-500 text-sm leading-none"
      >
        Fixed amount must be greater than 0.
      </p>
      <p
        v-if="
          $v.fixedAmount.$dirty && !$v.fixedAmount.required && $v.fixedAmount.$invalid
        "
        id="fixed-amount-feedback"
        class="mt-1 text-red-500 text-sm leading-none"
      >
        Fixed amount is required.
      </p>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { minValue, required } from 'vuelidate/lib/validators';
import toolkit from '@/app/mixins/toolkit/item';
import pension from '@/app/mixins/toolkit/pension/pension';

export default {
  name: 'pension-schedule-fixed-amount',
  mixins: [toolkit, pension],
  computed: {
    fixedAmount: {
      get() {
        if (this.pensions[this.activePension].fixedAmount === ''
          || this.pensions[this.activePension].fixedAmount === 0) {
          this.$v.$touch();
        }
        return this.pensions[this.activePension].fixedAmount;
      },
      set(value) {
        if (value === this.pensions[this.activePension].fixedAmount) return;
        this.setItem({ fixedAmount: value });
      },
    },
  },
  methods: {
    async setItem(data) {
      _.merge(this.pensions[this.activePension], data);
      await this.$store.dispatch('toolkit/updateItemKey', { data: { pensions: this.pensions } });
    },
  },
  watch: {
    $v: {
      deep: true,
      immediate: true,
      handler() {
        this.$emit('is-valid', !this.$v.$invalid);
      },
    },
  },
  validations() {
    if (this.isPartTwo) {
      return {
        fixedAmount: {
          required,
          maxValue: (value, vm) => +value <= vm.accumAmount,
          minValue: minValue(1),
        },
      };
    }
    return {
      fixedAmount: {
        required,
        minValue: minValue(1),
      },
    };
  },
};
</script>

<style></style>
